import { render, staticRenderFns } from "./ShowDarfPayments.vue?vue&type=template&id=2aa3a3ee&scoped=true"
import script from "./ShowDarfPayments.vue?vue&type=script&lang=js"
export * from "./ShowDarfPayments.vue?vue&type=script&lang=js"
import style0 from "./ShowDarfPayments.vue?vue&type=style&index=0&id=2aa3a3ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa3a3ee",
  null
  
)

export default component.exports